import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Home as HomeIcon, Building2, Wrench, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES } from "../../data/content";

const CARDS = [
  { icon: HomeIcon, title: "Residential HVAC", to: "/residential", image: IMAGES.residential, desc: "AC repair, installation, maintenance and heating to keep your home comfortable in every season." },
  { icon: Building2, title: "Commercial HVAC", to: "/commercial", image: IMAGES.commercial, desc: "Reliable commercial systems, walk-in coolers, electrical and service to keep your business running." },
  { icon: Wrench, title: "All Services", to: "/services", image: IMAGES.technician, desc: "Sales, service, repairs, installation and electrical — one licensed team for every HVAC need." },
];

export const WhatWeDo = () => {
  return (
    <section data-testid="what-we-do" className="surface-dark text-white py-24 lg:py-32">
      <div className="mx-auto w-[92%] max-w-[1280px]">
        <div className="max-w-2xl mb-14">
          <Reveal>
            <span className="font-mono text-[12px] font-bold uppercase tracking-[0.25em] text-fc-orange">What We Do</span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-display font-bold tracking-tight leading-[0.98] text-4xl md:text-6xl">
              Complete HVAC solutions.
            </h2>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {CARDS.map((c, i) => {
            const Icon = c.icon;
            return (
              <motion.div
                key={c.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
              >
                <Link
                  to={c.to}
                  data-testid={`whatwedo-card-${i}`}
                  className="group block h-full bg-white/[0.04] border border-white/10 overflow-hidden hover:border-fc-orange/50 transition-all"
                >
                  <div className="relative h-44 overflow-hidden">
                    <img src={c.image} alt={c.title} loading="lazy" decoding="async" className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    <div className="absolute inset-0 bg-gradient-to-t from-fc-navy/85 via-fc-navy/20 to-transparent" />
                    <div className="absolute bottom-3 left-3 h-11 w-11 grid place-items-center bg-fc-orange text-white">
                      <Icon size={20} />
                    </div>
                  </div>
                  <div className="p-7">
                    <h3 className="font-display text-2xl md:text-3xl font-semibold tracking-tight">{c.title}</h3>
                    <p className="mt-3 text-white/60 text-sm">{c.desc}</p>
                    <span className="mt-6 inline-flex items-center gap-1.5 text-fc-orange text-xs font-bold uppercase tracking-widest">
                      Explore <ArrowUpRight size={14} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                    </span>
                  </div>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
